import { render } from "./PersonalityMatrix.vue?vue&type=template&id=2d6877c6&scoped=true"
import script from "./PersonalityMatrix.vue?vue&type=script&lang=ts"
export * from "./PersonalityMatrix.vue?vue&type=script&lang=ts"

import "./PersonalityMatrix.vue?vue&type=style&index=0&id=2d6877c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d6877c6"

export default script